module.exports = __webpack_public_path__ + "static/media/31.63a07e22.mp3";